import ResearchGroupIntro from '../Components/ResearchGroupIntro';

const FinBussIntro = () => {
    return <ResearchGroupIntro route="/finBuss" />;
}
export default FinBussIntro;
